module.exports = () => {
  return {
    /** 落地页名称 */
    name: {
      label: '落地页名称',
      type: 'input',
      props: {
        placeholder: '请输入落地页名称',
      },
      value: '',
    },
  };
};
